import { register } from './../exports/theme-sections';
import { swatchSection } from './../exports/swatches';
import slickSlider from './../features/slick-slider';

register('collection-row', [swatchSection, slickSlider]);
